<script lang="ts">
    import TimesIcon from '$m7-library/component/Icons/TimesIcon.svelte';
    import type {Snippet} from 'svelte';

    let { onclose, children, padding = 'tw:px-5' }: { onclose: (event?: Event) => void, children: Snippet, padding?: string } = $props();

    let shouldCloseOnBackdropClick = false;

    function handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            onclose();
        }
    }

    function handleBackdropMouseDown(event: MouseEvent) {
        // Only allow closing if the mouse down event happened on the backdrop itself
        shouldCloseOnBackdropClick = event.target === event.currentTarget;
    }

    function handleBackdropClick(event: MouseEvent) {
        if (event.target === event.currentTarget && shouldCloseOnBackdropClick) {
            onclose();
        }
        shouldCloseOnBackdropClick = false;
    }
</script>

<!-- Overlay / Backdrop -->
<div class="tw:fixed tw:top-0 tw:left-0 tw:w-full tw:h-full tw:flex tw:items-start tw:justify-center tw:bg-cyprus/70 tw:backdrop-blur-sm tw:z-[1100] tw:p-4 tw:tracking-normal tw:overflow-y-auto"
     onmousedown={handleBackdropMouseDown}
     onclick={handleBackdropClick}
     onkeydown={handleKeydown}
     role="button"
     tabindex="0"
     aria-label="Close modal">

    <!-- Modal Container -->
    <div role="dialog"
         aria-modal="true"
         class="tw:flex tw:flex-col tw:justify-center tw:items-start tw:shrink-0 tw:w-full tw:max-w-[340px] tw:p-[10px] tw:rounded-[32px] tw:bg-white tw:shadow-2xl tw:relative tw:cursor-default tw:my-auto"
         onclick={(e) => e.stopPropagation()}
         onkeydown={(e) => e.stopPropagation()}
         tabindex="-1">

        <!-- Inneres Div -->
        <div class={`tw:flex tw:flex-col tw:items-center tw:gap-[20px] tw:pt-[35px] ${padding} tw:pb-[20px] tw:bg-[#EBEFF0] tw:w-full tw:rounded-[24px] tw:break-keep`}>
            {@render children()}
        </div>

        <!-- Close Button (Moved after Inner Div to ensure it's on top) -->
        <button type="button" onclick={onclose} aria-label="Close modal"
                class="tw:absolute tw:top-6.5 tw:right-6.5 tw:text-gray-400 tw:cursor-pointer tw:hover:text-cyprus tw:z-10">
            <TimesIcon class="tw:w-6.5 tw:h-6.5" />
        </button>
    </div>
</div>
